import { useMemo } from 'react';

import { detectPlatform, type Platform } from '@/utils/helpers/platform.helpers';

/**
 * The device's platform, for store routing (GIFTWEB-27, GIFTWEB-30).
 *
 * Computed once per mount: a user agent does not change under a running page,
 * so re-deriving it on every render would only cost work.
 */
export default function usePlatform(): Platform {
  return useMemo(() => detectPlatform(), []);
}
